import { Box, Typography } from '@mui/material';
import { Slide } from '../../components/composites/Slider';
import React, { useState } from 'react';
import { DifficultyLevelEnum } from '@protos/content_management/content.db_pb';
import { StepperComponent } from '../../components/composites/Stepper';
export const Slider = () => {
  interface SliderLevel {
    key: DifficultyLevelEnum;
    value: number;
    label?: string;
  }

  const [slideValue, setslideValue] = useState<SliderLevel>({
    key: 3,
    value: 50,
    label: 'Medium',
  });

  const sliderLevels = [
    { key: DifficultyLevelEnum.DIFFICULTY_LEVEL_LOW, value: 0, label: 'Easy' },
    { key: DifficultyLevelEnum.DIFFICULTY_LEVEL_UNDEFINED, value: 25 }, // Between Easy and Medium
    {
      key: DifficultyLevelEnum.DIFFICULTY_LEVEL_MEDIUM,
      value: 50,
      label: 'Medium',
    },
    { key: DifficultyLevelEnum.DIFFICULTY_LEVEL_UNDEFINED, value: 75 }, // Between Medium and Hard
    {
      key: DifficultyLevelEnum.DIFFICULTY_LEVEL_HIGH,
      value: 100,
      label: 'Hard',
    },
  ];

  // const sliderLevels = [
  //   { key: 1, value: 0, label: 'Easy' },
  //   { key: 2, value: 25 }, // Between Easy and Medium
  //   { key: 3, value: 35 },
  //   { key: 4, value: 50, label: 'Medium' },
  //   { key: 5, value: 75 }, // Between Medium and Hard
  //   { key: 6, value: 85 },
  //   { key: 7, value: 100, label: 'Hard' },
  // ];

  return (
    <Box sx={{ width: '60%', m: 'auto' }}>
      <Slide
        sliderLevels={sliderLevels}
        titleText="Overall Difficulty"
        isDisable={false}
        minLevel={0}
        maxLevel={100}
        step={25}
        slideValue={slideValue}
        SliderOnChangeValue={(val: any) => setslideValue(val)}
      />

      <Box>
        <Typography variant="h3">
          Difficulty: Key:{slideValue.key}, Value: {slideValue.value}, Lable:{' '}
          {slideValue.label}
        </Typography>
      </Box>
    </Box>
  );
};
